import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { useEffect, useState } from "react";
import { getRenterById, updateRenterCommercialActions } from "../../../../common/services/renters.api";
import { IRenter } from "../../../../types/renter.type";
import FormCommecialActions from "../forms/FormCommecialActions";
import Loading from "../../../../common/components/ui/loading/Loading";

type Props = {
  data: { auth: string, renterId: string }
  onClose: () => void
}


export default function CommercialActions(props: Props) {
  const renterId = props.data.renterId
  const [renterData, setRenterData] = useState<IRenter | null>(null)
  const { notifySuccess, notifyError } = useToastContext();

  useEffect(() => {
    async function loadRenterData(renterId: string) {
      if (!renterId) return;

      const { data, ok } = await getRenterById(renterId)

      if (ok) {
        setRenterData(data as IRenter)
      }
    }

    setRenterData(null)

    if (renterId) loadRenterData(renterId)

  }, [renterId])

  async function saveRenter(dataToSave: Partial<IRenter>) {
    try {
      const response = await updateRenterCommercialActions(renterId as string, dataToSave)

      const { ok, data, errors } = response;
      if (ok && data) {
        setRenterData(data as IRenter)
        notifySuccess(`Cliente "${renterData?.name}" atualizado!`)
        return { ok, data: data as IRenter, errors: (errors as [{ message: string, path: string[] }]) }
      }

      if (!ok) {
        notifyError(response.message as string)
      }

      return { ok, data: data as IRenter, errors: errors as [{ message: string, path: string[] }] }
    } catch (err) {
      console.log(err)
      notifyError('Erro ao tentar salvar cliente, tente novamente')
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }


  const handleCloseModal = () => { props.onClose() }
  return (
    <Modal
      size={'3xl'}
      className='relative'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="dark:text-black">
        <span className="dark:text-black">{`Ações comerciais: ${renterData?.name}`}</span>
      </Modal.Header>
      <Modal.Body className="dark:text-black">
        {renterData ? (
          <FormCommecialActions
            onSubmit={saveRenter}
            data={renterData!}
          />
        ) : <Loading />}
      </Modal.Body>
      <Modal.Footer>
      </Modal.Footer>
    </Modal>
  )
}